import { useQuery } from '@vue/apollo-composable';
import { MODULE_CLONE_CURRICULUM } from '@/graphql/Queries/moduleCurriculum';
import type { ModuleCloneCurriculumQuery } from '@/types/operations';

export function useModuleCloneCurriculum(programmeId: Ref<string>) {
  const { result, loading } = useQuery<ModuleCloneCurriculumQuery>(MODULE_CLONE_CURRICULUM,
    () => ({ programmeId: Number(programmeId.value) }), () => ({ enabled: !!programmeId.value }));
  return { curriculum: computed(() => result.value?.listCurriculumsByProgram ?? []), loading };
}
